import { useEffect, useRef } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { REPORT_ACTION_PARAM, type ReportAction, readReportAction } from './reportAction';

/** Wait for the real report controls, then consume the handoff so refresh does not reopen them. */
export function useReportAction(action: ReportAction, open: () => void, ready = true) {
  const location = useLocation();
  const navigate = useNavigate();
  const callback = useRef(open);
  callback.current = open;
  useEffect(() => {
    if (!ready || readReportAction(location.search) !== action) {
      return;
    }
    const params = new URLSearchParams(location.search);
    params.delete(REPORT_ACTION_PARAM);
    const search = params.toString();
    navigate(
      { pathname: location.pathname, search: search ? `?${search}` : '', hash: location.hash },
      { replace: true, state: location.state },
    );
    callback.current();
  }, [action, location.hash, location.pathname, location.search, location.state, navigate, ready]);
}
